import React from 'react';

import { IFooter20Fields } from '../../../../../types/contentful';

import { Disclaimers } from './Disclaimers';
import { LegalNavLinks } from './LegalNavLinks';
import { PageFootnotes } from './PageFootnotes';

export function Legal({
  legalLinks,
  pageFootnotes,
  isAffiliateFooter,
  disableGlobalConfigFootnotes
}: IFooter20Fields) {
  return (
    <div
      className="bg-[#000] px-5 py-10 tablet:px-10 desktop:mb-0 desktop:mt-0 desktop:px-15"
      data-blockid="legal-footer20"
      data-testid="legal-footer20"
    >
      <div className="column w-full items-center pb-3 pt-3 desktop:justify-center">
        {/* BrightEdge Autopilot */}
        <div className="be-ix-link-block" />
      </div>
      <div id="legal-layout" className="flex flex-col gap-5">
        <LegalNavLinks
          links={legalLinks}
          isAffiliateFooter={isAffiliateFooter}
        />
        <div className="gap-4">
          {pageFootnotes && <PageFootnotes {...pageFootnotes} />}
          {!disableGlobalConfigFootnotes && <Disclaimers />}
        </div>
      </div>
    </div>
  );
}
